module.exports = __webpack_public_path__ + "img/chart-breakout-square.85300c65.svg";